import {NetworkState} from '@mintdata-wsp/common/state/RootState';
import {ImportInstance} from '@mintdata-wsp/common/state/ui/visualDesigner/ImportState';
import {UploadInstance} from '@mintdata-wsp/common/state/ui/visualDesigner/SurfaceFileUploadState';
import {GUID} from '@mintdata/mint-kit/api/models/GUID';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';
import {observable} from 'mobx';

export type ToastId = GUID

export enum ErrorSubMessages
{
    Support = 'support',
}

export class ToastData
{
    public readonly id:ToastId;
    public readonly renderer:(toast:ToastData) => JSX.Element;
    public readonly isAutoHide:boolean;
    public readonly hideDelay:number;
    @observable public count:number;

    public constructor(renderer:(toast:ToastData) => JSX.Element,
                       isAutoHide:boolean = true,
                       hideDelay:number = 5000)
    {
        this.id = IdUtil.newGUID();
        this.renderer = renderer;
        this.isAutoHide = isAutoHide;
        this.hideDelay = hideDelay;
        this.count = 1;
    }
}

export class ErrorToastData extends ToastData
{
    public readonly message:string;
    public readonly subMessage:string | ErrorSubMessages;
    public readonly stackTrace:string;

    public constructor(message:string,
                       subMessage:string | ErrorSubMessages,
                       stackTrace:string,
                       renderer:(toast:ToastData) => JSX.Element,
                       isAutoHide:boolean = true,
                       hideDelay:number = 5000)
    {
        super(renderer, isAutoHide, hideDelay);

        this.message = message;
        this.subMessage = subMessage;
        this.stackTrace = stackTrace;
    }
}

export class ImportTabsToastData extends ToastData
{
    public readonly importInstance:ImportInstance;

    public constructor(importInstance:ImportInstance,
                       renderer:(toast:ToastData) => JSX.Element)
    {
        super(renderer, false);

        this.importInstance = importInstance;
    }
}

export class FileUploadToastData extends ToastData
{
    public readonly uploadInstance:UploadInstance;

    public constructor(uploadInstance:UploadInstance,
                       renderer:(toast:ToastData) => JSX.Element)
    {
        super(renderer, false);

        this.uploadInstance = uploadInstance;
    }
}

export class SocketReconnectionToastData extends ToastData
{
    public readonly networkState:NetworkState;

    public constructor(networkState:NetworkState,
                       renderer:(toast:ToastData) => JSX.Element)
    {
        super(renderer, false);

        this.networkState = networkState;
    }
}

export class SlowConnectionToastData extends ToastData
{
    public readonly networkState:NetworkState;

    public constructor(networkState:NetworkState,
                       renderer:(toast:ToastData) => JSX.Element)
    {
        super(renderer, false);

        this.networkState = networkState;
    }
}